import { observer } from "mobx-react-lite";

import { useAuthStore } from "src/auth";

import { UserAvatar } from "./UserAvatar";

export const CurrentUserAvatar = observer(function CurrentUserAvatar() {
  const authStore = useAuthStore();

  return (
    <UserAvatar
      name={authStore.user.name}
      src={authStore.user.avatarUrl ?? undefined}
    />
  );
});
